import React from 'react';

export const SUPPORT_EMAIL = 'support@vertivio.com';

/**
 * A way to reach a person that does not depend on the ticket screens working, shown on the
 * Support and Help pages for every kind of account.
 */
function SupportEmailLine({ className }) {
  return (
    <p className={className || 'fs-6 text-gray-700 mb-0'} data-testid="support-email-line">
      Need help? Email <a href={'mailto:' + SUPPORT_EMAIL}>{SUPPORT_EMAIL}</a>
    </p>
  );
}

export default SupportEmailLine;
